<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Today New Partners</div>
        <div>
          <bread-crumb :bread-crumbs="['Partner Summary']" />
        </div>
      </v-card-title>

      <v-data-table fixed-header  height="55vh"
        :headers="dessertHeaders"
        :items="partnerSummary"
        dense
        :search="search"
        item-key="name"
      >
        <template v-slot:item.Bank="{ item }">
          <a
            class="text-decoration-underline"
            @click="bankPage()"
            :title="item.Bank"
          >
            {{ item.Bank }}
          </a>
        </template>
        <template v-slot:item.contact_person="{ item }">
          <span class="font-weight-bold">{{ item.contact_person }}</span>
          <p class="pa-0 ma-0">{{ item.contact_person_email }}</p>
        </template>
        <template v-slot:item.Branch="{ item }">
          <a
            class="text-decoration-underline"
            @click="Branchname()"
            :title="item.Branch"
          >
            {{ item.Branch }}
          </a>
        </template>
        <template v-slot:item.Commission="{ item }">
          <a
            class="text-decoration-underline"
            @click="Payoutcommission()"
            :title="item.Commission"
          >
            {{ item.Commission }}
          </a>
        </template>
        <template v-slot:item.partner_name="{ item }">
          <a
            class="border-b width-anchor"
            @click="
              $router.push({
                name: 'Create Partner',
                query: { partner_id: item.partner_id },
              })
            "
            >{{ item.partner_name }}</a
          >
        </template>
        <template v-slot:item.status="{ item }">
          <v-btn
            depressed
            x-small
            @click="openBlockDialog(item)"
            color="success"
            title="Block user"
            class="text-capitalize"
            v-if="item.status"
          >
            Active
          </v-btn>
          <v-btn
            depressed
            x-small
            @click="openBlockDialog(item)"
            color="warning"
            class="text-capitalize"
            title="Unblock user"
            v-else
          >
            Block
          </v-btn>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <!-- <v-badge color="grey" content="1" small shape="circle"> -->
            <v-icon
              small
              title="Agents"
              color="primary"
              class="mr-2"
              @click="
                $router.push({
                  name: 'Agent Summary',
                  query: {
                    parent_partner_id: item.partner_id,
                    partner_name: item.partner_name,
                    country_cd: item.company_country_code,
                  },
                })
              "
            >
              mdi-account-tie
            </v-icon>
            <!-- </v-badge> -->
            <!-- <v-badge color="grey" content="1" small shape="circle"> -->
            <v-icon
              small
              title="Branches"
              color="success"
              class="mr-2"
              @click="
                $router.push({
                  name: 'Branch Summary',
                  query: { parent_partner_id: item.partner_id },
                })
              "
            >
              mdi-domain
            </v-icon>
            <!-- </v-badge> -->
            <v-icon
              small
              color="primary"
              class="mr-2"
              @click="
                $router.push({
                  name: 'partnerBank Summary',
                  query: {
                    parent_partner_id: item.partner_id,
                    name: item.partner_name,
                  },
                })
              "
            >
              mdi-bank
            </v-icon>
            <!-- <v-icon
                small
                color="primary"
                class="mr-2"
                @click="deleteItem(item)"
              >
                mdi-trash-can-outline
              </v-icon> -->
          </div>
        </template>

        <template v-slot:top>
          <v-divider class="p-0 m-0 primary--text"></v-divider>
          <v-col class="mt-5">
            <v-row>
              <v-col class="mt-1">
                <v-btn
                  depressed
                  small
                  class="text-capitalize me-3 text-decoration-none"
                  color="primary"
                  to="/createPartner"
                  ><v-icon small>mdi-content-save-plus-outline</v-icon>Add
                  Partner</v-btn
                >
                <v-btn
                  depressed
                  @click="downloadExcelsheet"
                  color="primary"
                  small
                  ><v-icon small>mdi-file-excel-outline</v-icon>Export
                </v-btn>
              </v-col>
              <v-col></v-col>
            </v-row>
            <v-row>
              <v-col></v-col>
              <v-col cols="12" md="4"
                ><v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Type here to filter the table data."
                  hide-details
                  class="me-4 mb-2"
                  dense
                  clearable
                ></v-text-field
              ></v-col>
            </v-row>
          </v-col>
        </template>
        <!-- <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">More info about {{ item.name }}</td>
          </template> -->
      </v-data-table>
      <v-dialog persistent v-model="dialogDelete" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete this prameter?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteItemConfirm"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn depressed small color="primary" outlined @click="closeDelete"
              ><v-icon>mdi-close</v-icon></v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="showBlockDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom"
            >Update Partner Status</v-card-title
          >
          <v-card-text class="h5 py-3"
            >Partner status is {{ isActive ? "Active" : "Blocked" }} .Are you
            sure you want to {{ title_text }} Partner?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="confirmBlock(isActive ? false : true)"
            >
              {{ title_text }}<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="showBlockDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import alerts from "@/mixins/alerts";
import partnerService from "@/services/partnerService/partnerService.js";
import userService from "@/services/UserService/userService.js";
export default {
  mixins: [alerts],
  name: "Partner Summary",
  data() {
    return {
      // expanded: [],
      search: "",
      dialogDelete: false,
      showUnblockDialog: false,
      showBlockDialog: false,
      isActive: null,
      blockId: null,
      loader: false,
      title: "",
      title_text: "",
      dessertHeaders: [
        {
          text: "Partner Id",
          value: "partner_id",
        },
        { text: "Partner Name", value: "partner_name", width: "150px" },
        { text: "Partner Code", value: "partner_code" },
        { text: "Partner Type", value: "partner_type_data.value" },
        { text: "Contact Person", value: "contact_person" },
        { text: "Country", value: "company_country_code" },
        { text: "Currency", value: "local_currency" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action", sortable: false },
      ],
      partnerSummary: [],
      tempPartnerSummary: [],
      bankPage() {
        this.$router.push({ name: "Bank List" });
      },
      Branchname() {
        this.$router.push({ name: "Partner Branch" });
      },
      Payoutcommission() {
        this.$router.push({ name: "Payout Commission" });
      },
    };
  },
  components: {
    BreadCrumb,
    OverlayPageVue,
  },
  mounted() {
    this.getpartnersummary(true);
  },
  methods: {
    async downloadExcelsheet() {
      if (this.partnerSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.partnerSummary,
          "partnerSummary"
        );
      }
    },
    deleteItem(item) {
      console.log("item", item);
      this.dialogDelete = true;
      this.deleteId = item.partner_id;
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedIndex = -1;
        this.deleteId = "";
      });
    },
    navBank(item) {
      this.$router.push({ name: "partnerBank Summary", params: item });
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        setTimeout(() => {
          this.loader = false;
        }, 400);
        const responseData = await partnerService.deletePartner(this.deleteId);
        this.response = responseData;
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getpartnersummary();
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
      } catch (e) {
        console.log(e);
        this.showAlertError("One or more parameter is invalid or missing!");
      }

      this.closeDelete();
    },
    async getpartnersummary(today) {
      this.loader = true;
      try {
        const responseData = await partnerService.getAllPartners({
          today,
        });
        if (responseData && responseData.data.status_code == 200) {
          this.partnerSummary = responseData.data.data;
          this.loader = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("summary", this.partnerSummary);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },

    async totalpartners() {
      this.loader = true;
      try {
        const responseData = await userService.getTotalPartners();
        if (responseData && responseData.data.status_code == 200) {
          this.partnerSummary = responseData.data.data;
          this.loader = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("totalpartners", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },
    async partnersCurrentdate() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTodayPartners();
        if (responseData && responseData.data.status_code == 200) {
          this.partnerSummary = responseData.data.data;
          this.loader = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("totalpartners", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Fetched data Failed: Something went wrong");
      }
    },

    openBlockDialog(item) {
      this.title_text = item.status ? "Block" : "Unblock";
      this.showBlockDialog = true;
      this.isActive = item.status;
      this.blockId = item.partner_id;
    },

    async confirmBlock(active_status) {
      this.showBlockDialog = false;
      this.loader = true;
      try {
        const responseData = await partnerService.blockPartner(
          active_status,
          this.blockId
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess("Status is Updated : Success");
          this.getpartnersummary();
          this.loader = false;
        } else {
          this.showAlertError("Failed:" + responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        console.log(e);
        this.loader = false;
        this.showAlertError("Status update failed: Something went wrong");
      }

      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";
.width-anchor {
  width: 200px !important;
}
</style>
